<template>
  <div>
    <TransitionFade>
      <div class="w-full" v-if="show">
        <div v-if="showVideo" class="w-full h-full bg-white bg-opacity-50 flex items-center justify-center absolute z-100">
          <div class="w-full lg:w-3/5" v-click-away="closeVideoModal">
            <span class="absolute top-32 right-32 2xl:top-24 2xl:right-80 cursor-pointer text-white" aria-hidden="true" @click="closeVideoModal">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12" style="filter: drop-shadow(0px 1px 1px rgb(0 0 0 / 0.4))" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </span>
            <VideoGuide v-if="$store.state.Langs.selected.lang == 'pt'" video="https://player.vimeo.com/video/816282120?h=247a6eb42c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" />
            <VideoGuide v-else video="https://player.vimeo.com/video/816282177?h=51f84ea751&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" />
          </div>
        </div>
        <div class="py-20 px-5 md:px-10 xs:p-0 mx-auto w-full">
          <div class="absolute top-5 right-5">
            <SelectLangs />
          </div>
          <div class="w-full">
            <div class="text-center mb-6">
              <div class="inline-flex space-x-6">
                <svg class="w-60 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 285.76 99.82" fill="currentColor"> 
                  <path d="M270.57 14A13.77 13.77 0 0 0 257.26.19h-77.74L178 6.71h78.88A7.3 7.3 0 0 1 264 14a7.47 7.47 0 0 1-.26 1.84l-11.51 49.34a.75.75 0 0 1-.18.34 7.3 7.3 0 0 1-6.71 4.61h-75.08a2.69 2.69 0 0 0-1.77.65l-18.66 17.56 3.79-14.86a2.19 2.19 0 0 0 .11-.67 2.5 2.5 0 0 0-2.53-2.63h-137a7.31 7.31 0 0 1-7.29-7.3 5 5 0 0 1 .07-.78.66.66 0 0 1 0-.28l11.5-49.2a.54.54 0 0 1 .07-.19 7.24 7.24 0 0 1 6.65-5.56.53.53 0 0 1 .24-.06L127 6.79 128.59.2 25.39.23a7.32 7.32 0 0 0-1.24.1 13.71 13.71 0 0 0-11.88 10 6.25 6.25 0 0 0-.23.77L.55 60.29a7.89 7.89 0 0 0-.19 1.45v1.1a13.86 13.86 0 0 0 13.79 13.85h131.16l-4.23 17.38a7.05 7.05 0 0 0-.13 1 4.74 4.74 0 0 0 7.83 3.58l24.05-22 72.33.06h.71a13.94 13.94 0 0 0 11.95-8 7.36 7.36 0 0 0 .78-2l11.51-49.22a13.93 13.93 0 0 0 .45-3.42ZM285.45 6.29a5.86 5.86 0 0 1-.45 2.23 5.46 5.46 0 0 1-1.2 1.87 5.88 5.88 0 0 1-1.71 1.25 6 6 0 0 1-2.61.59 5.8 5.8 0 0 1-2.37-.48 5.9 5.9 0 0 1-1.83-1.21 6.43 6.43 0 0 1-1.16-1.62 6.13 6.13 0 0 1-.28-4.6 5.79 5.79 0 0 1 .84-1.6 6.76 6.76 0 0 1 1.22-1.23 5.8 5.8 0 0 1 1.66-.86 6.32 6.32 0 0 1 1.94-.31 5.87 5.87 0 0 1 2.57.59 5.55 5.55 0 0 1 1.71 1.22 6.25 6.25 0 0 1 1.12 1.63 5.88 5.88 0 0 1 .55 2.53m-5.95-5a4.86 4.86 0 0 0-2.08.47 5.3 5.3 0 0 0-1.33.94A5.05 5.05 0 0 0 275 4.25a4.53 4.53 0 0 0-.44 2 5 5 0 0 0 .66 2.46 4.62 4.62 0 0 0 1.81 1.83 4.84 4.84 0 0 0 4.88 0 4.62 4.62 0 0 0 1.81-1.83 5 5 0 0 0 .66-2.46 4.72 4.72 0 0 0-.21-1.41 5 5 0 0 0-.6-1.29 5.33 5.33 0 0 0-1-1.16 4.89 4.89 0 0 0-1.44-.81 4.8 4.8 0 0 0-1.61-.29m-.88 8.26h-1.7V3h2.76a3 3 0 0 1 2 .54 1.67 1.67 0 0 1 .64 1.35 1.69 1.69 0 0 1-.43 1.2 1.71 1.71 0 0 1-1.18.49 2 2 0 0 1 .84.32 1.31 1.31 0 0 1 .51.63 2.33 2.33 0 0 1 .16.9V9a1.85 1.85 0 0 0 .11.58h-1.64a4.37 4.37 0 0 1-.11-1 1.92 1.92 0 0 0-.15-.8.9.9 0 0 0-.42-.37 2.83 2.83 0 0 0-1-.12h-.36v2.3Zm0-3.52h.67a1.4 1.4 0 0 0 1-.28.9.9 0 0 0 .3-.71.82.82 0 0 0-.42-.76 1.91 1.91 0 0 0-.9-.17h-.63v1.96Z" fill="currentColor"></path><path d="m185.4 62.31 1.41-5.84h-.17c-2.15 3.65-6.95 7.38-11.2 7.38-7.8 0-11.19-3.57-9.64-10l9.38-39h13.49l-8.17 34c-.36 2.2-.23 4.15 2.35 4a5 5 0 0 0 4.86-4l8.18-34h13.49L198 62.31ZM228.82 14.8l-1.39 5.76h.17c3.77-4.75 8-6.95 12.75-7.13 8.91 0 9.42 8.83 7.62 16.3L244 46.2c-1.94 8.06-6.12 17.31-16 17.65-2.4.08-6.38-1.36-8.4-6h-.17L215.29 73H201.8l14.46-58.2Zm5.05 17.48c.67-2.8 1.87-7.81-2-7.81-3.65 0-5.33 3.82-6.44 8.4l-2.68 11.2c-1 4.08-1.28 8.83 2.05 8.74 4.33 0 5.41-5.17 6.14-8.23l3-12.3ZM43.2 14.8l-1.32 5.51h.17a17.06 17.06 0 0 1 11.75-6.88c4.38-.25 7.93 2.3 8.5 6.29h.17C66 15.47 70 13.43 73.82 13.43c6.37 0 11.22 3.48 9.67 9.93l-9.36 39H60.64l8.15-33.94c.37-2.21 0-4.07-2.62-3.9a4.62 4.62 0 0 0-4.59 3.9l-8.15 33.89h-13.5l8.15-33.94c.07-2 0-3.9-2.28-3.9-2.71 0-4.14 1.36-4.93 3.9l-8.15 33.94h-13.5L30.64 14.8ZM103.84 58.07c-4.29 3.74-7.67 5.78-13 5.78-7.64 0-11.15-5.18-9.33-12.73C84.08 40.34 90.75 37 97.16 35s12.32-2.55 13.55-7.64c.63-2.62-.35-4.91-3.07-4.91-4.92 0-5.73 3.39-6.94 7.38H87.2c2.26-11.89 11.32-16.39 22.18-16.39 13.33 0 17.18 4.08 14.68 14.52l-7 29.11a15.26 15.26 0 0 0-.16 5.25h-13.15l.09-4.24Zm4-18.84c-3.06 1.45-5.62 2.21-7.62 3.49a9.22 9.22 0 0 0-4.61 6.11c-.72 3 .56 5.09 3.78 5.09 4 0 5.84-4.16 6.66-7.21l1.79-7.48ZM122.25 62.31l11.42-47.51h13.5l-11.43 47.51Zm12.54-52.18L137.19 0h13.49l-2.4 10.09ZM142.87 62.31 157.77.04h13.5l-14.91 62.27h-13.49zM10.51 99.7h5.56c3.85 0 5.59-2.17 6.11-4.69.48-2.13-.41-3.47-2.15-3.72v-.05a4.39 4.39 0 0 0 3.23-3.5c.66-3.07-1.05-4-3.75-4H14l-3.48 16Zm6.25-13.64H18c1.63 0 2.27.56 1.92 2.09s-1.28 2.11-3.09 2.11h-.93l.91-4.2Zm-1.4 6.44h1.42c1.45 0 2.41.54 2 2.4a2.81 2.81 0 0 1-3.16 2.43h-1.28l1-4.83Zm11.36-8.81-3.48 16h9.36l.57-2.64h-6.06l.94-4.31h5.49l.57-2.65h-5.49l.82-3.77h5.84l.57-2.64ZM46 86.06h1.56c1.49 0 2.13.74 1.81 2.22a2.74 2.74 0 0 1-3 2.41H45l1-4.63ZM39.74 99.7H43l1.46-6.77h1.77c1.32 0 1.74.76 1.51 2L47.2 98a2.78 2.78 0 0 0 0 1.68h3.57v-.13c-.55-.32-.43-1.19-.11-2.87.71-3.39.62-4.6-1.56-4.89 1.95-.38 3.11-1.81 3.59-4 .6-2.74-.75-4.12-3.45-4.12h-6.02l-3.48 16ZM56 83.69l-3.48 16h9.36l.57-2.64h-6.11l.94-4.31h5.49l.57-2.65h-5.49l.82-3.77h5.84l.57-2.64Zm16.66 16 .57-2.64h-5.88l2.9-13.37H67l-3.48 16Zm5-16-3.48 16h9.36l.46-2.63h-6l.93-4.31h5.5L85 90.1h-5.54l.82-3.77h5.84l.57-2.64Zm9.93 0 .28 16H92l7.23-16h-3.4l-5 11.84h-.07L91 83.69ZM95 99.7h3.43l1.49-3.39h4.35v3.39h3.43l-.84-16h-4.08L95 99.7Zm9.2-13.23v7.2H101l3.14-7.2Zm8.15-2.78-3.48 16h3l2.43-11.21L116 99.7h3.75l3.48-16h-3l-2.38 11-1.6-11Zm12.27 0-.62 2.64h3.57l-2.88 13.37H128l2.9-13.37h3.57l.57-2.64Z" fill="currentColor"></path> 
                </svg>
                <img src="https://lp.mailup.com/es/wp-content/themes/mailup/images/logos/logo-mailup-light.svg" class="w-60" />
                <div class="flex items-center" v-if="showPoweredBySetUp">
                  <div class="inline-flex items-center space-x-2 px-4 py-2 rounded-lg bg-white shadow-md poweredby">
                    <div class="text-sm font-semibold">{{ $t("mailupView.powered", {}, { locale: $store.state.Langs.selected.lang }) }}</div>
                    <Brand size="small" />
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!loginLoader" class="flex flex-col w-full mx-auto sm:rounded-lg shadow-xl md:max-w-lg bg-white mt-3 divide-y divide-dashed">
              <div class="alert alert-error p-2.5 m-4" v-if="messageDomainInvalidate">
                <div class="flex-1">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                        class="w-10 h-10 mt-2 mr-2 stroke-current">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
                  </svg>
                  <label class="text-lg">{{ $t('acumbamailView.messageDomainInvalidate') }}</label>
                </div>
              </div>
              <div v-if="!messageDomainInvalidate" class="w-full py-8 px-6 md:px-8">
                <h3 class="text-gray-500 font-normal text-sm leading-tight mb-3">{{ $t("mailupView.platformAlready") }}</h3>
                <SocialLogin v-if="!$store.state.Auth.isLoginSuccess" :show="['mailup']" paramsExtra="add_credentials_driver=true" :urlRedirect="urlRedirect" :mailupText="$t('signin_mailup')" />
              </div>
              <div v-if="!messageDomainInvalidate" class="w-full py-8 px-6 md:px-8">
                <h3 class="text-gray-800 font-semibold leading-tight">{{ $t("mailupView.createPlatformAsk") }}</h3>
                <div class="my-4">
                  <h3 class="text-gray-500 font-normal text-sm leading-tight">{{ $t("mailupView.before") }}</h3>
                  <button @click="openVideoModal" type="button" class="inline-flex items-center px-3 py-2 mt-1 mb-2 text-sm leading-4 font-medium bg-white text-gray-600 hover:text-gray-700 rounded-lg shadow-md hover:bg-gray-50 border border-gray-200 transition hover:border-gray-300 focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring"><VideoCameraIcon class="-ml-0.5 mr-2 h-4 w-4" aria-hidden="true" /> {{ $t("mailupView.integrationGuide") }}</button>
                </div>
                <button type="button" class="flex items-center w-full justify-center mt-4 text-white bg-blue-500 rounded-lg shadow-md hover:bg-blue-600 border border-blue-200 transition relative focus:border-blue-300 focus:ring-blue-200 focus:outline-none focus:ring" @click="$router.push({ name: 'CreateAccountMailUp' })">
                  <span class="px-0 py-3 flex-1 text-center font-semibold">{{ $t("mailupView.createPlatform") }}</span>
                  <span class="absolute right-5"><Icon name="airplane" class="w-6 h-6 text-white stroke-current transform rotate-90" /></span>
                </button>
              </div>
            </div>
            <div v-if="loginLoader" class="flex flex-col w-full mx-auto sm:rounded-lg shadow-xl md:max-w-lg bg-white mt-3 divide-y divide-dashed">
              <h1 class="py-8 text-center text-gray-700 font-semibold leading-tight">{{ $t("mailupView.loading") }}</h1>
              <div class="p-10 flex flex-col justify-center items-center">
                <Spinner color="blue" size="small" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </TransitionFade>
  </div>
</template>

<script>
import SelectLangs from "@/components/SelectLangs"
import Brand from "@/components/Brand"
import Icon from "@/components/Icon"
import SocialLogin from "@/components/SocialLogin"
import TransitionFade from "@/components/TransitionFade"
import axiosClient from "@/config/AxiosClient"
import VideoGuide from "@/components/UI/VideoGuide"
import Spinner from "@/components/UI/Spinner"
import { VideoCameraIcon } from "@heroicons/vue/solid"

export default {
  name: "MailUpLogin",
  components: {
    Brand,
    Icon,
    SocialLogin,
    TransitionFade,
    VideoGuide,
    VideoCameraIcon,
    Spinner,
    SelectLangs
  },
  computed: {
    urlRedirect() {
      return `${window.location.origin}/m/login`
    }
  },
  data: function () {
    return {
      showPoweredBySetUp: false,
      show: false,
      showVideo: false,
      login: false,
      driver: localStorage.getItem("driver"),
      account_uuid: localStorage.getItem("account_uuid"),
      loginLoader: false,
      messageDomainInvalidate: false
    }
  },
  mounted() {
    if(this.$route.query.domainInvalidate){
      this.messageDomainInvalidate = true
      this.show = true
      return;
    }
    if (this.$route.query.driver != undefined) {
      this.driver = this.$route.query.driver
      this.account_uuid = this.$route.query.account_uuid
      localStorage.setItem("driver", this.driver)
      localStorage.setItem("account_uuid", this.account_uuid)
    }
    if (this.$route.query.access_token) this.loginSuccess(this.$route.query.access_token, this.$route.query.user_social_id)
    this.show = true
  },
  methods: {
    loginSuccess: async function (token, user_social_id) {
      this.loginLoader = true

      await this.$store.dispatch("Auth/loginSuccess")
      await this.$store.dispatch("Auth/setTokenLocalStorage", token)
      await this.$store.commit("Auth/setExternalLogin", true)
      await this.$store.dispatch("Auth/getUser")

      let response = await axiosClient.post(`/api/2.0/vinculate/account${this.account_uuid != null ? `/${this.account_uuid}` : ""}`, { user_social_id, channel_output_id: 2 })

      let redirect = async (accounts) => {
        this.$store.commit("Accounts/setAccount", accounts)
        setTimeout(() => {
          this.$router.push({ name: "DashboardMailup" })
        }, 1000)
      };

      if(response.data.tenant) {
        let checkTenant = setInterval(async () => {
          let tenantResponse = await axiosClient.post(`/api/2.0/vinculate/account${this.account_uuid != null ? `/${this.account_uuid}` : ""}`, { user_social_id, channel_output_id: 2 })

          if(tenantResponse.data.accounts) {
            clearInterval(checkTenant);

            await redirect(tenantResponse.data.accounts);
          }
        }, 5000);

        return true;
      }

      await redirect(response.data.accounts);
    },
    openVideoModal: function () {
      this.showVideo = true
    },
    closeVideoModal: function () {
      this.showVideo = false
    }
  }
}
</script>
